import IMask from 'imask';

export const masks = {
  cpf: '000.000.000-00',
  cnpj: '00.000.000/0000-00',
  security_card_code: '0000',
  br_postal_code: '00000-000',
  card_number: '0000 0000 0000 0000',
  month: '00',
  year: '0000',
  payment_card_validity: '00/00',
  brazilian_phone: '+00 (00) 00000-0000',
  cep: '00000-000',
  birthdate: '00/00/0000',
};

const createMask = (mask: IMask.AnyMaskedOptions) => IMask.createMask(mask);

export const applyIdentityMask = (value: string) => {
  const identityMasker = createMask({ mask: [{ mask: masks.cpf }, { mask: masks.cnpj }] });

  return identityMasker.resolve(value);
};

export const applyMask = (value: string, maskType: keyof typeof masks) => {
  const masker = createMask({ mask: masks[maskType] });

  return masker.resolve(value);
};
